import React from "react";
import NFLink from "app/components/NFLink/NFLink";
import Image from "next/image";
import Button from "app/components/Button/Button";
import ArrowRightIcon from "@heroicons/react/24/outline/ArrowRightIcon";
import {usePhrase} from "app/i18n";
import StarIcon from "@heroicons/react/16/solid/StarIcon";
import StarIconOutline from "@heroicons/react/24/outline/StarIcon";
import {formatCurrencySymbol, formatPriceStyle} from "../../utilities/price";

;


const ProductCard = (props) => {

    const {storeCode, store, _t, inSlider} = props;

    const t = usePhrase(_t);

    let imagePriority = props?.imagePriority === true;


    return (
        <div key={'product_card_' + props.id}
             className={[`w-full  ${!inSlider ? ' py-2 lg:py-1' : ''}  `, props.className].join(' ')}>
            <NFLink scroll={true}
                    storeCode={storeCode}
                    href={props.url || ''}
                    className={'block w-full h-full'}>

                <div className="flex flex-col h-full ">

                    <div className="relative flex flex-1 justify-start lg:mb-2  group">
                        <div
                            className={'relative w-[70%] lg:w-[55%] after:bg-[#00000005] after:top-0 after:left-0 after:block after:absolute after:w-full after:h-full   overflow-hidden min-h-[350px] lg:min-h-[196px]'}>
                            {props.smallImage ? <>
                                <Image
                                    src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/catalog/product' + props.smallImage}
                                    alt={props.name}
                                    priority={imagePriority}
                                    fill
                                    sizes="(min-width: 1200px) 650px, (min-width: 1000px) 350px, (min-width: 600px) 300px, 100vw"
                                    className="h-full lg:h-auto lg:w-full object-cover lg:object-contain lg:aspect-square object-center lg:group-hover:scale-110  ease-in duration-200"/>
                            </> : <>
                                <div className={'w-full no-image bg-gray-50  aspect-square '}></div>
                            </>}
                        </div>

                        <div className={`flex flex-col  justify-between pl-2 w-[30%] lg:w-[45%] `}>

                            {props?.features && props.features.filter(feature => feature.featured).map((feature, index) =>
                                <div key={['attr', props?.sku, feature.name].join('_')}
                                     className={`flex flex-col relative items-center lg:items-start text-center`}>
                                    <span className={`order-2 lg:order-1 text-xs text`}>{feature.first_title}</span>
                                    <span
                                        className={`order-3 lg:order-2 text-sm text-[#e7bb43] font-bold`}>{feature.second_title}</span>
                                    <div
                                        className={`order-1 lg:order-3 lg:absolute lg:top-0 lg:right-0 flex justify-center`}>
                                        <Image
                                            src={process.env.NEXT_PUBLIC_MEDIA_URL + '/media/features/image/' + feature.image}
                                            alt={feature.title}
                                            priority={false}
                                            width={35}
                                            height={35}
                                            sizes="30px"/>
                                    </div>
                                </div>)}


                        </div>


                        {props.discount_percentage && <>
                            <div
                                className={`bg-[#111213] p-1 absolute top-1 left-1 text-white text-xs opacity-70`}>{props.discount_percentage}% {t('OFF')}</div>


                        </>}

                        {props.isNew &&
                            <div
                                className={`bg-[#e7bb43] p-1 absolute bottom-1 left-1 text-[#111213]  text-xs opacity-90`}>{t('NEW')}</div>}

                        {inSlider && <>
                            {/*
                            <div className={`bg-[#11121380] py-2 px-2 absolute top-1 left-1 text-white text-lg uppercase`}>{props.name}</div>
*/}
                            <div
                                className="bg-[#11121380] absolute bottom-0 left-0 flex w-full justify-between py-2  px-3">

                                <div className="grow flex-col items-start">
                                    <h4 className={'text-lg font-bold text-white uppercase'}>{props?.name}</h4>
                                    <div className={'text-white'}>
                                        <div className={'text-sm'}>{t('From')}</div>
                                        <div>{props.discount_percentage && props.final_price_incl_tax !== null ? <>
                                                <span
                                                    className={'line-through text-xs lg:text-sm  mr-1'}>{formatPriceStyle(props.price_incl_tax, true)} {formatCurrencySymbol(store?.default_display_currency_code)}</span>
                                                <span
                                                    className={'text-md lg:text-md'}>{formatPriceStyle(props.final_price_incl_tax)} {formatCurrencySymbol(store?.default_display_currency_code)}{props.price_unit && <>/{props.price_unit}</>}</span></> :
                                            <span
                                                className={'text-md lg:text-lg'}>{formatPriceStyle(props.price)} {formatCurrencySymbol(store?.default_display_currency_code)}{props.price_unit && <>/{props.price_unit}</>}</span>}</div>
                                    </div>
                                </div>


                            </div>
                        </>}
                    </div>

                    {!inSlider && <div className="prod-box  flex flex-2 flex-col grow ml-2 lg:ml-0">
                        <div className="prod-info flex grow justify-start flex-col">
                            <div className={`mb-2`}>
                                <ul className={`hidden lg:block`}>
                                    {props.features && props.features.filter(feature => !feature.featured).map(feature =>
                                        <li key={['attr', props.sku, feature.name].join('_')}
                                            className={'w-full flex   '}>
                                            <div className={'py-0.5.5 flex items-center w-[55%]'}>
                                                <div className={'w-2 h-2 rounded-full bg-[#e7bb43] mr-3'}/>
                                                <span className={'text-sm capitalize'}>{feature.first_title}</span>
                                            </div>
                                            <div className={'py-0.5 pl-3 text-sm capitalize flex items-center'}>
                                                <span>{feature.second_title}</span>
                                            </div>
                                        </li>)}
                                </ul>
                            </div>
                            <div className="prod-title mb-1">
                                <h2 className={`uppercase font-bold`}>{props?.name}</h2>
                                <h2 className={'text-sm lg:text-sm font-normal '}>{props?.shortDescriptionSanitized ? (props?.shortDescriptionSanitized.length > 240 ? props.shortDescriptionSanitized.substr(0, 240).trim() + '..' : props?.shortDescriptionSanitized) : ''}</h2>
                                {/* <p className={'text-xs text-[#555] text-justify'}>{props.shortDescriptionSanitized}</p>*/}
                            </div>
                            <div className="mb-3">
                                <div className={'flex items-center'}>
                                    <div className={'flex space-x-0.5 -ml-[0.1rem]'}>
                                        {[...Array(Math.floor(props?.reviews_average || 0))].map((n, i) => <StarIcon
                                            key={['pc', 'starrs', 'col', props.id, i].join('_')}
                                            className={'h-4 w-4 text-[#e7bb43]'}/>)}
                                        {[...Array(5 - Math.floor(props?.reviews_average || 0))].map((n, i) =>
                                            <StarIconOutline
                                                key={['pc', 'starrs', 'uncol', props.id, i].join('_')}
                                                className={'h-4 w-4 text-[#e7bb43]'}/>)}
                                    </div>
                                    <div className={'ml-1'}><span
                                        className={'text-xs'}>{props?.reviews_count || 0}</span></div>
                                </div>
                                <p className={'text-xs lg:text-md'}>{t('From')}</p>
                                <p>{props.discount_percentage && props.final_price_incl_tax !== null ? <>
                                        <span
                                            className={'line-through text-xs lg:text-base text-[#555] mr-1'}>{formatPriceStyle(props.price_incl_tax, true)} {formatCurrencySymbol(store?.default_display_currency_code)}</span>
                                        <b className={'text-md lg:text-lg'}>{formatPriceStyle(props.final_price_incl_tax)} {formatCurrencySymbol(store?.default_display_currency_code)}{props.price_unit && <>/{props.price_unit}</>}</b></> :
                                    <b className={'text-md lg:text-lg'}>{formatPriceStyle(props.price)} {formatCurrencySymbol(store?.default_display_currency_code)}{props.price_unit && <>/{props.price_unit}</>}</b>}
                                </p>
                            </div>
                        </div>
                        <div className="flex w-full justify-between">

                            <div className="w-full">
                                <Button className={'text-left flex justify-between'}>
                                    <span>{t('Details')}</span>
                                    <span className={'absolute right-2'}><ArrowRightIcon className={'h-5 w-5'}/></span>
                                </Button>
                            </div>

                            {/* <div className="w-12">
                                <WishlistButton className="flex justify-center items-center px-0" storeCode={storeCode} productId={props.id} _t={_t}/>
                            </div>*/}
                        </div>
                    </div>}
                </div>

            </NFLink>
        </div>
    );

}

export default ProductCard;